import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
export function sortObjectByKeys(object, keys) {
  var _context, _context2;
  object = object || {};
  var otherKeys = _filterInstanceProperty(_context = _Object$keys(object)).call(_context, function (key) {
    return _indexOfInstanceProperty(keys).call(keys, key) < 0;
  });
  return _reduceInstanceProperty(_context2 = _concatInstanceProperty(keys).call(keys, otherKeys)).call(_context2, function (obj, key) {
    if (object[key]) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
}
export function filterObjectByKeys(array, keys) {
  var _context3, _context4;
  return _reduceInstanceProperty(_context3 = _filterInstanceProperty(_context4 = _Object$keys(array)).call(_context4, function (key) {
    return _includesInstanceProperty(keys).call(keys, key);
  })).call(_context3, function (obj, key) {
    obj[key] = array[key];
    return obj;
  }, {});
}
export function objectsEqual(objectA, objectB) {
  var objectAKeys = _Object$keys(objectA),
    objectBKeys = _Object$keys(objectB);
  var index = objectAKeys.length;
  if (objectAKeys.length !== objectBKeys.length) {
    return false;
  }
  while (index--) {
    var key = objectA[index];
    if (!objectB[key]) {
      return false;
    }
    if (objectA[key] !== objectB[key]) {
      return false;
    }
  }
  return true;
}